export default __webpack_public_path__ + "static/media/pwaiOS.7e46796e.mp4";